import { createApp } from "vue";
import { createPinia } from "pinia";
import axios from "axios";

import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";

import VueApexCharts from "vue3-apexcharts";
import "leaflet/dist/leaflet.css";

import "@/assets/fonts.css";
import "@/assets/tailwind.css";

/* Vuetify */
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "@mdi/font/css/materialdesignicons.css";

const vuetify = createVuetify({
  components,
  directives,

  rtl: true,

  theme: {
    defaultTheme: "light",
  },

  defaults: {
    global: {
      style: {
        fontFamily: "LBC-Regular, Arial, sans-serif",
      },
    },
  },
});

const pinia = createPinia();
const app = createApp(App);

/* إعداد Axios عالميًا */
app.config.globalProperties.$axios = axios;

/* رابط API */
axios.defaults.baseURL = "http://localhost:8000/api";
axios.defaults.headers.common.Accept = "application/json";

/* تسجيل إضافات Vue */
app.use(pinia);
app.use(i18n);
app.use(vuetify);
app.use(router);
app.use(VueApexCharts);

/* تشغيل التطبيق */
app.mount("#app");
